export default {
    staging: {
        TENANT_NAME: "glsgrouptest",
        CLIENT_ID: "6f591173-51a8-43c8-ad35-c855180c516a",
        SIGN_IN_POLICY: "B2C_1A_STAGE_DE_DF_SOCIAL_DEFAULT/V2.0",
        SCOPE_URL: "https://glsgrouptest.onmicrosoft.com/20e0a3cc-bb96-4a5f-ac47-f779c99e0bb7",
        AUTHORITY_DOMAIN: "test.login.gls-group.net"
    },
    prod : {
        TENANT_NAME: "glsgroup",
        CLIENT_ID: "b990fae6-1647-426b-b0a9-d51fcfed4fc8",
        SIGN_IN_POLICY: "B2C_1A_PROD_DE_DF_SOCIAL_DEFAULT/V2.0",
        SCOPE_URL: "https://glsgroup.onmicrosoft.com/1635def9-6f7b-4720-be2d-7b49f8298756",
        AUTHORITY_DOMAIN: "login.gls-group.net"
    }
}